module.exports = __webpack_public_path__ + "f197336503dd44484d896737287d0624.svg";